function generateUuid(): string {
	return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

let cachedSessionId: string | null = null;

function getAddSearchSessionId(): string {
	if (typeof window !== "undefined") {
		if (!cachedSessionId) {
			cachedSessionId = localStorage.getItem("addsearch-session-id") || generateUuid();
			localStorage.setItem("addsearch-session-id", cachedSessionId);
		}
	}
	return cachedSessionId ?? generateUuid();
}

const ADDSEARCH_PUBLIC_KEY = "e9e98fd1e13129ff013e35c04f3ef6a6";

export async function reportAddSearchClick({
	keyword,
	docid,
	position,
	url,
	tag,
}: {
	keyword: string;
	docid: string | null | undefined;
	position?: number;
	url?: string;
	tag?: string;
}) {
	const sessionId = getAddSearchSessionId();

	const payload: Record<string, any> = {
		action: "click",
		session: sessionId,
		keyword,
		docid,
	};

	if (position !== undefined) payload.position = position;
	if (url) payload.url = url;
	if (tag) payload.tag = tag;

	try {
		await fetch(`https://api.addsearch.com/v1/stats/${ADDSEARCH_PUBLIC_KEY}`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(payload),
		});
	} catch (err) {
		console.warn("AddSearch analytics error:", err);
	}
}
